import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/api.service';
import { Observable } from 'rxjs';
import { IFilters, IPagination, IUser } from '../../../../modules/authorization/store/types';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {

    constructor(private apiService: ApiService) { }

    public fetchAll(data: IFilters): Observable<IPagination<IUser>> {
        return this.apiService.get('/users', data);
    }

    public fetchOne(id: string): Observable<IUser> {
        return this.apiService.get(`/users/${id}`);
    }

    public add(data: any): Observable<any> {
        return this.apiService.post('/users', data);
    }

    public update(id: string, data: any): Observable<any> {
        return this.apiService.put(`/users/${id}`, data);
    }

    public delete(id: string): Observable<any> {
        return this.apiService.delete(`/users/${id}`);
    }

    public bulkAction(action: string, ids: string[], active?: boolean): Observable<any> {
        return this.apiService.post(`/users/bulk/${action}`, { ids, active });
    }

}
